var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-title-container"},[_c('span',[_vm._v(_vm._s(_vm.step)+"/"+_vm._s(_vm.steps))]),_c('div',[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('span',[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }